import React from 'react';
import {
    // Badge,
    ButtonGroup,ButtonToolbar,Card,CardBody,CardTitle,Col,Row,Table,
    // FormGroup,Input,InputGroup,InputGroupAddon
    } from 'reactstrap';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import Constants from '../../../config/constants';
import $ from 'jquery'; 
import BlockUi from 'react-block-ui';

import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';

/* modules for validation */
import { isEmail, isLength, isNumeric, isAlpha } from 'validator';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'

import Moment from 'react-moment';
import moment from 'moment';

import Pagination from "react-js-pagination";

class Subscription extends React.Component{
    constructor(props){
        super(props);
        let superAdminId = localStorage.getItem("superAdminId");
        let superAdminToken = localStorage.getItem("superAdminToken");

        this.state ={
            superAdminId: superAdminId,
            superAdminToken: superAdminToken,
            page: 1,
            search: "",
            delayTimer: 0,
            blocking: false,
            showForAddSchool: false,
            addUserName: "",
            radioValue: "",
            addUserYOB: "",
            addUserEmail: "",
            addUserPassword: "",
            show: false,
            editName: "",
            editRadio: "",
            editYOB: "",
            editEmail: "",
            editPass: "",
            currentSchoolId: 0,
            selectedState: null,
            stateOptions: [],
            userListing: [],
            currentEditId: 0,
            checksubscription: 0,
            currentSubscribeId: 0,

            activePage: 1,
            pageSize: 10,
            finalPagesCount: 1,

            labelHolder: 1
        }
        this.schoolList = this.schoolList.bind(this);
        this.openAddOfficer = this.openAddOfficer.bind(this);
        this.closeForAddOfficer = this.closeForAddOfficer.bind(this);
        this.handleAddOfficerChange = this.handleAddOfficerChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.confirmDeleteUser = this.confirmDeleteUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.showEditSchool = this.showEditSchool.bind(this);
        this.closeEditSchool = this.closeEditSchool.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleEditSubmit = this.handleEditSubmit.bind(this);
        this.userList = this.userList.bind(this);
        this.resetAddUser = this.resetAddUser.bind(this);
        this.resetEditUser = this.resetEditUser.bind(this);
        this.handleSubscribe = this.handleSubscribe.bind(this);
        // this.isMoreData = this.isMoreData.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.myFunction1 = this.myFunction1.bind(this);
        this.myFunction = this.myFunction.bind(this);
      }


    	/**** Component life cycle method ***/
        componentWillMount() {
            // this.schoolList(); //get schoolList Details
            this.userList();
        }

        // componentDidMount() {
        //   window.scrollTo(0, 0)
        // }

    // get school listing
    schoolList() {
          
          var _that = this;
          var param = { page_number: _that.state.page, page_size: _that.state.pageSize, account_type: "SCHOOL"
            // , search: _that.state.search.trim(), designationId: _that.state.selectId
        }
          _that.setState({ blocking: true });
       
          fetch(Constants.SERVER_URL + "admin/accounts?" + $.param(param), {
            method: 'GET', 
            headers: {                
              "Accept": "application/json",
              "Content-type": "application/json",
              "Authorization": _that.state.superAdminToken
            }
          }).then(function (response) {
            
            if(response.status === 200){
              let responseData = response.json();
              responseData.then(function (data) {
                
                _that.setState({ blocking: false});
         
                if (data.data.length == _that.state.pageSize) {
                  _that.setState({
                    isMore: true
                  });
                } else {
                  _that.setState({
                    isMore: false
                  });
                }

                if (_that.state.page == 1) {
                    
                  _that.setState({ blocking: false, 
                    stateOptions: data.data 
                  });
                  
                }
                else if (data.data.length > 0) {
                  let oldData = JSON.parse(JSON.stringify(_that.state.stateOptions));
                  let newData = JSON.parse(JSON.stringify(data.data));
                  let totalData = oldData.concat(newData);
  
                  _that.setState({ stateOptions: totalData, blocking: false });
                } else if (_that.state.searchExist == false) {
                  
                  let oldData = JSON.parse(JSON.stringify(_that.state.stateOptions));
                  let newData = JSON.parse(JSON.stringify(data.data));
                  let totalData = oldData.concat(newData);
  
                  _that.setState({ stateOptions: totalData, blocking: false });
                } else {
                  _that.setState({ blocking: false, stateOptions: data.data, page: 1 });
                }
                
              })
            
            } else{
              let responseData = response.json();
              responseData.then(function (data) {
                
                _that.setState({ blocking: false});
               
                Alert.error('<h5>' + data.message + '</h5>', {
                  position: 'top-right',
                  effect: 'slide',
                  beep: false,
                  timeout: 3000,
                  offset: Constants.OffSetValue
                });
              })
            }
          }).catch(function (error) {
            _that.setState({ blocking: false });
            if (navigator.onLine) {
              Alert.error('<h5>' + Constants.SERVER_CONNECTION_ISSUE + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 3000,
                offset: Constants.OffSetValue
              });
            } else {
              Alert.error('<h5>' + Constants.INTERNET_CONNECTION_ISSUE + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 3000,
                offset: Constants.OffSetValue
              });
            }
          });

    }


     // get user listing
     userList(school_id) {
        
        var _that = this;
        var param = { page_number: _that.state.activePage, page_size: _that.state.pageSize
          //  school_id: school_id
          , search_text: _that.state.search.trim(),
           designationId: _that.state.selectId
      }
        _that.setState({ blocking: true });
     
        fetch(Constants.SERVER_URL + "admin/subscription?" + $.param(param), {
          method: 'GET', 
          headers: {                
            "Accept": "application/json",
            "Content-type": "application/json",
            "Authorization": _that.state.superAdminToken
          }
        }).then(function (response) {
        
          if(response.status === 200){
            let responseData = response.json();
            responseData.then(function (data) {
            
              _that.setState({ blocking: false});
       
              // if (data.data.length == _that.state.pageSize) {
              //   _that.setState({
              //     isMore: true
              //   });
              // } else {
              //   _that.setState({
              //     isMore: false
              //   });
              // }

              // if (_that.state.page == 1) {
                //  let pagesCount;
                //  pagesCount = Math.ceil( (data.totalSubscriptions) / _that.state.pageSize );
                //  console.log(_that.state.pageSize,"_+++++==============>>>>>>>>", pagesCount);
                _that.setState({ blocking: false, 
                  userListing: data.data, finalPagesCount: data.totalSubscriptions 
                });
              // }
              // else if (data.data.length > 0) {
              //   let oldData = JSON.parse(JSON.stringify(_that.state.userListing));
              //   let newData = JSON.parse(JSON.stringify(data.data));
              //   let totalData = oldData.concat(newData);

              //   _that.setState({ userListing: totalData, blocking: false });
              // } else if (_that.state.searchExist == false) {
                
              //   let oldData = JSON.parse(JSON.stringify(_that.state.userListing));
              //   let newData = JSON.parse(JSON.stringify(data.data));
              //   let totalData = oldData.concat(newData);

              //   _that.setState({ userListing: totalData, blocking: false });
              // } else {
              //   _that.setState({ blocking: false, userListing: data.data, page: 1 });
              // }
              
            })
          
          } else{
            let responseData = response.json();
            responseData.then(function (data) {
              
              _that.setState({ blocking: false});
             
              Alert.error('<h5>' + data.message + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 3000,
                offset: Constants.OffSetValue
              });
            })
          }
        }).catch(function (error) {
          _that.setState({ blocking: false });
          if (navigator.onLine) {
            Alert.error('<h5>' + Constants.SERVER_CONNECTION_ISSUE + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
            });
          } else {
            Alert.error('<h5>' + Constants.INTERNET_CONNECTION_ISSUE + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
            });
          }
        });

  }


    openAddOfficer(){
      
      if(this.state.currentSchoolId != 0){
      this.setState({showForAddSchool: true });
      } else {
        Alert.error('<h5>' + Constants.Select_School_First + '</h5>', {
          position: 'top-right',
          effect: 'slide',
          beep: false,
          timeout: 2000,
          offset: Constants.OffSetValue
        });
      }
    }


    closeForAddOfficer(event){
      
      this.setState({ showForAddSchool: false});
      this.resetAddUser();
    };


     /**** function to handle change for add officer popup ****/
     handleAddOfficerChange(event) {
      
      if (event.target.id == 'addUserName') {
        this.setState({ addUserName: event.target.value });
      } else if (event.target.id == 'radio1') {
        this.setState({ radioValue: "MALE" });
      } else if (event.target.id == 'radio2') {
        this.setState({ radioValue: "FEMALE" });
      } else if (event.target.id == 'addUserYOB') {
        this.setState({ addUserYOB: event.target.value });
      } else if (event.target.id == 'addUserEmail') {
        this.setState({ addUserEmail: event.target.value });
      } else if (event.target.id == 'addUserPassword') {
        this.setState({ addUserPassword: event.target.value });
      } 
      // else if (event.target.id == 'addUserSchoolId') {
      //   this.setState({ addUserSchoolId: event.target.value });
      // }
       else {
        
      }
      return true;
    }

    
    resetAddUser(){
      this.setState({
        addUserName: "",
        radioValue: "",
        addUserYOB: "",
        addUserEmail: "",
        addUserPassword: "",
      })
    }


     // Add Users submit button
     handleSubmit(e){
      e.preventDefault();
      var _that = this;
      if (_that.state.addUserName.trim() != undefined && _that.state.addUserName.trim() != null && _that.state.addUserName.trim() != "") {
          if(_that.state.radioValue.trim() != undefined && _that.state.radioValue.trim() != null && _that.state.radioValue.trim() != ""){
      
      
      _that.setState({ blocking: true });
              
      fetch(Constants.SERVER_URL + "admin/user", {
          method: 'POST', 
          headers: {                
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              "Authorization": _that.state.superAdminToken
          },
          body:JSON.stringify({
            user_name: _that.state.addUserName.trim(),
            gender: _that.state.radioValue,
            year_of_birth: Number(_that.state.addUserYOB.trim()),
            email: _that.state.addUserEmail,
            password: _that.state.addUserPassword.trim(),
            school_id: _that.state.currentSchoolId
          }),
        }).then(function (response) {
        
          if(response.status === 200){
            let responseData = response.json();
            responseData.then(function (data) {
             
              _that.setState({ blocking: false,  showForAddSchool: false});
              _that.resetAddUser();
              _that.userList(_that.state.currentSchoolId);
              
              Alert.success('<h5>' + "Varification mail has been send to register Email" + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 4000,
                offset: Constants.OffSetValue
              });
              
            })
          
          } else{
            let responseData = response.json();
            responseData.then(function (data) {
              
              _that.resetAddUser();
              _that.setState({ blocking: false,  showForAddSchool: false});
             
              Alert.error('<h5>' + data.message + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 3000,
                offset: Constants.OffSetValue
              });
            })
          }
        }).catch(function (error) {
          _that.setState({ blocking: false,  showForAddSchool: false });
          _that.resetAddUser();
          if (navigator.onLine) {
            Alert.error('<h5>' + Constants.SERVER_CONNECTION_ISSUE + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
            });
          } else {
            Alert.error('<h5>' + Constants.INTERNET_CONNECTION_ISSUE + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
            });
          }
        });
  
      } else{
          
          Alert.error('<h5>' + "Please Select Gender" + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
          });
      }
  
      } else{
          
          Alert.error('<h5>' + "Name Shouldn't be blank" + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
          });
      }
    }

    handleSubscribe(event){
        
        if (event.target.id == 'subscribe') {
            this.setState({ checksubscription: 1 });
          } else if (event.target.id == 'subscribe1') {
            this.setState({ checksubscription: 6 });
          } else if (event.target.id == 'subscribe2') {
            this.setState({ checksubscription: 12 });
          }  
          return true;
    }

    // Subscribe alert
    confirmDeleteUser(id) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className='confirmpopup custom-ui'>
              <div className="con_header">
              {/* <h1>Confirm to Block tap {tap_number} on plant {this.state.currentPlantName}?</h1> */}
                <h1>Subscription {this.state.checksubscription}</h1>
              </div>
              <div className="con_body">
                

                        <div className="formbox">
                            <label>Subscription</label>
                            <input type="radio" id="subscribe" name="gender" onChange={this.handleSubscribe} checked={this.state.checksubscription == 1}/>1 month
                            <input type="radio" id="subscribe1" name="gender" onChange={this.handleSubscribe} checked={this.state.checksubscription == 6}/>6 month
                            <input type="radio" id="subscribe2" name="gender" onChange={this.handleSubscribe} checked={this.state.checksubscription == 12}/>12 month<br></br>
                        </div>


                
              </div>
              <div className="con_footer">
              <button className="nobtn" onClick={onClose}>Cancel</button>
                {/* <button className="nobtn" onClick={() => {this.suru();}}>Cancel</button> */}
                <button onClick={() => {
                  this.deleteUser(id);
                  // alert("test");
                  onClose()
                }}>Delete</button>
              </div>
            </div>
          )
        },
        closeOnClickOutside: false
      })
    };

    // API function to Delete single School
    deleteUser(id){
    var _that = this;

    if(_that.state.checksubscription != 0){
    if(id){
        _that.setState({ blocking: true });
        fetch(Constants.SERVER_URL + "admin/user/" + id  , {
          method: 'DELETE',
          headers: {                
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              "Authorization": _that.state.superAdminToken
          }
        }).then(function (response) {
       
          if(response.status === 204){
            // let responseData = response.json();
            // responseData.then(function (data) {
              _that.userList(_that.state.currentSchoolId);
              Alert.success('<h5>' + "Successfully deleted" + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 2000,
                offset: Constants.OffSetValue
              });
            // })
          } else if(response.status === 401){
            // let responseData = response.json();
            // responseData.then(function (data) {
              _that.setState({ blocking: false});
              Alert.error('<h5>' + Constants.Unauthorized_Access + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 2000,
                offset: Constants.OffSetValue
              });
              
            // })
          } else{
            // let responseData = response.json();
            // responseData.then(function (data) {
              _that.setState({ blocking: false});
              Alert.error('<h5>' + Constants.Something_Wrong + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 2000,
                offset: Constants.OffSetValue
              });
            // })
          }
        }).catch(function (error) {
          
          _that.setState({ blocking: false });
          if (navigator.onLine) {
            Alert.error('<h5>' + Constants.SERVER_CONNECTION_ISSUE + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
            });
          } else {
            Alert.error('<h5>' + Constants.INTERNET_CONNECTION_ISSUE + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
            });
          }
        });
      } else{
        Alert.error('<h5>' + Constants.Something_Wrong + '</h5>', {
          position: 'top-right',
          effect: 'slide',
          beep: false,
          timeout: 3000,
          offset: Constants.OffSetValue
        });
      }

        }else{
            Alert.error('<h5>' + "Select Subscription Plan First" + '</h5>', {
                position: 'top-right',
                effect: 'slide',
                beep: false,
                timeout: 3000,
                offset: Constants.OffSetValue
              });
        }
  }



    // show function for edit School popup
    showEditSchool(stateData){
      
      this.setState({show: true, 
        currentSubscribeId: stateData.id
        // , editName: stateData.user_name, editRadio: stateData.gender,
        // editEmail: stateData.email, editYOB: stateData.year_of_birth
      });
    }

    // close function for add state popup
    closeEditSchool(event){
      
      this.setState({ show: false
        // , currentIdForAddState: "" 
      });
      this.resetEditUser();
      
    };

    handleChange(event) {
      event.preventDefault();
      
      if (event.target.id === "editName") {
        this.setState({ editName: event.target.value });
      } else if (event.target.id === "editRadio1") {
        this.setState({ editRadio: "MALE" });
      }  else if (event.target.id === "editRadio2") {
        this.setState({ editRadio: "FEMALE" });
      }  else if (event.target.id === "editYOB") {
        this.setState({ editYOB: event.target.value });
      }  else if (event.target.id === "editEmail") {
        this.setState({ editEmail: event.target.value });
      } else if (event.target.id === "editPass") {
        this.setState({ editPass: event.target.value });
      } 
      // else if (event.target.id === "insertStateSN") {
      //   this.setState({ insertStateSN: event.target.value });
      // }
      return true;
  } 

  resetEditUser(){
    this.setState({
    editName: "",
    editRadio: "",
    editYOB: "",
    editEmail: "",
    editPass: ""});
  }


  // currentSubscribeId popup submit
  handleEditSubmit(e){
    e.preventDefault();
    var _that = this;
    if (_that.state.checksubscription != 0) {
    //     if(_that.state.editRadio.trim() != undefined && _that.state.editRadio.trim() != null && _that.state.editRadio.trim() != ""){
    
    
    _that.setState({ blocking: true });
            
    fetch(Constants.SERVER_URL + "/admin/subscription", {
        method: 'POST', 
        headers: {                
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "Authorization": _that.state.superAdminToken
        },
        body:JSON.stringify({
            user_id: _that.state.currentSubscribeId,
            length: _that.state.checksubscription
        }),
      }).then(function (response) {
      
        if(response.status === 200){
          // let responseData = response.json();
          // responseData.then(function (data) {
           
            _that.setState({ blocking: false,  show: false});
           
            _that.userList(_that.state.currentSchoolId);
            _that.resetEditUser();
            Alert.success('<h5>' + "Success" + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 2000,
              offset: Constants.OffSetValue
            });
            
          // })
        
        } else{
          // let responseData = response.json();
          // responseData.then(function (data) {
            
            _that.setState({ blocking: false,  show: false});
            _that.resetEditUser();
            Alert.error('<h5>' + Constants.Something_Wrong + '</h5>', {
              position: 'top-right',
              effect: 'slide',
              beep: false,
              timeout: 3000,
              offset: Constants.OffSetValue
            // });
          })
        }
      }).catch(function (error) {
        _that.setState({ blocking: false,  show: false });
        if (navigator.onLine) {
          Alert.error('<h5>' + Constants.SERVER_CONNECTION_ISSUE + '</h5>', {
            position: 'top-right',
            effect: 'slide',
            beep: false,
            timeout: 3000,
            offset: Constants.OffSetValue
          });
        } else {
          Alert.error('<h5>' + Constants.INTERNET_CONNECTION_ISSUE + '</h5>', {
            position: 'top-right',
            effect: 'slide',
            beep: false,
            timeout: 3000,
            offset: Constants.OffSetValue
          });
        }
      });

    // } else{
    
    //     Alert.error('<h5>' + "Address Shouldn't be blank" + '</h5>', {
    //         position: 'top-right',
    //         effect: 'slide',
    //         beep: false,
    //         timeout: 3000,
    //         offset: Constants.OffSetValue
    //     });
    // }

    } else{
        
        Alert.error('<h5>' + "Please Select Subscription First" + '</h5>', {
            position: 'top-right',
            effect: 'slide',
            beep: false,
            timeout: 3000,
            offset: Constants.OffSetValue
        });
    }
  }

    selectState = selectedState => {
        this.setState({ selectedState }
            , () => { 
                this.userList(selectedState.id); 
            this.setState({ currentSchoolId: selectedState.value}) 
            }
            );
        
    };

    // // is more button functionality
    // isMoreData(){
      
    //   this.setState({page: this.state.page + 1},() => {this.userList()});
    // }

    // for pagination
    handlePageChange(pageNumber) {
     
      // this.setState({activePage: pageNumber});
      this.setState({activePage: pageNumber},() => {this.userList()});
    }

    myFunction1(myString, cb){
      // alert(myString);
      let _labelHolder = (this.state.labelHolder + 1);
      this.setState({labelHolder: _labelHolder}
        // ,() => {console.log("rama", this.state.labelHolder)}
        );
      cb(null, myString);
    }

    myFunction(dyC){
      var _that = this;
      _that.myFunction1(dyC, function(err, result){
        // console.log(err,"this suru result", result);
        alert(_that.state.labelHolder);
      })
    }

    /**** function to search Handle event ****/
    searchHandle = (event) => {
      if (event.target.id == "search") {
        clearTimeout(this.state.delayTimer);
        this.setState({ search: event.target.value }, () => {
          this.setState({
            delayTimer: setTimeout(function () {
              this.userList();
            }.bind(this), 700),
            activePage: 1
          });
        })
      }
    }


    render(){
      
        const { selectedState, stateOptions, userListing } = this.state;
        

        let isMorebtn;
        if(userListing.length > 0){
          isMorebtn =  <Pagination
          // prevPageText='prev'
          // nextPageText='next'
          // firstPageText='first'
          // lastPageText='last'
          activePage={this.state.activePage}
          itemsCountPerPage={this.state.pageSize}
          totalItemsCount={this.state.finalPagesCount}
          // pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
        } else{
            isMorebtn = ""
        }

        const required = (value, props) => {
          if (!value || (props.isCheckable && !props.checked)) {
            return <span className="validationForm">Required</span>;
          }
        };

        const minContactNo = (value, props) => {
          if (!isLength(value, { min: 10 })) {
            return <span className="validationForm">Please Enter a Valid Contact Number</span>;
          }
        };
    
        const maxContactNo = (value, props) => {
            if (!isLength(value, { max: 10 })) {
                return <span className="validationForm">Please Enter a Valid Contact Number</span>;
            }
        };
    
        const minNo = (value, props) => {
            if (!isLength(value, { min: 6 })) {
              return <span className="validationForm">Please Enter Min six character</span>;
            }
        };
    
        const maxNo = (value, props) => {
            if (!isLength(value, { max: 32 })) {
                return <span className="validationForm">Max password length exceed</span>;
            }
        };
    
        const number = (value) => {
          if (!isNumeric(value)) {
            return <span className="validationForm">Please Enter a Number</span>;
          }
        };

        const email = (value) => {
          if (!isEmail(value)) {
            return <span className="form-error is-visible">Please enter a valid Email</span>;
          }
        };

        let schoolListing, schoolAlldata, name, plan_validity, expire_date, userEmail, date_subscribed, platform, schoolId;
        schoolListing = userListing.map((list, index) => {

            // if(list.status === 2){
            //   forgetPassStatus = <button type="button" className="btn btn-warning officerCursor">Yes</button>;
            // }else{
            //   forgetPassStatus = <div className="officerStatus">No</div>
            // }
  
                    //   if (list.status == 1) {
                    //       orderStatusView = <b className="btn btn-info">Pending</b>;
                    //   } else if (list.status == 2) {
                    //       orderStatusView = <b className="btn btn-success">Completed</b>;
                    //   } else if (list.status == 3) {
                    //       orderStatusView = <b className="btn btn-danger">Cancel</b>;
                    //   } 


                      if(list.id != null){
                        schoolId = list.id;
                      } else{
                        schoolId = "-";
                      }
                      
                      if(list.name != null){
                        name = list.name;
                      } else{
                        name = "-";
                      }

                      if(list.email != null){
                        userEmail = list.email;
                      }else{
                          userEmail = "-";
                      }
                      
                      if(list.plan_validity != null  && list.platform != "MadeToGrow"){
                        plan_validity = list.plan_validity + " month";
                      } else{
                        plan_validity = "-";
                      }
  
                        if(list.date_subscribed != null){
                          
                            date_subscribed=  <Moment format="DD/MM/YYYY">{Number(list.date_subscribed)}</Moment>;
                            // date_subscribed=moment(Number(list.date_subscribed)).format('l');
                        } else{
                          
                            date_subscribed=  "-"
                        }

                        if(list.expire_date != null){
                          expire_date = list.expire_date;
                        }else{
                            expire_date = "-";
                        }

                        if(list.platform != null ){
                          platform = list.platform;
                        }else{
                            platform = "-";
                        }
                        

                      return (
                          <tr key={index} >
                              {/* <td><input type="checkbox" className="form-check-input" onChange={this.selectHandleChange} id="singleCheckBox" value={school.email} />Select</td> */}
                              <td>{schoolId}</td>
                              <td>{name}</td>
                              <td>{userEmail}</td>
                              <td className="text-center">{plan_validity}</td>
                              <td>{date_subscribed}</td>
                              <td>{expire_date}</td>
                              <td>{platform}</td>
                            {/* <td>{forgetPassStatus}</td>*/}
                            
                                {/* <button className="btn btn-info" onClick={() => {this.confirmDeleteUser(school.id)}}>Subscribe</button> */}
                            {/* <button type="button" className="btn btn-secondary" onClick={() => {this.showEditSchool(school)}} data-toggle="modal" data-target="#myModal">Subscribe</button> */}
                            {/* <td>{date_subscribed}
                            </td>  */}
                          </tr>
                      )
                  })

          if(userListing.length > 0){
              schoolAlldata =	<div className="table-responsive"><table className="table table-striped">
              <thead>
                  <tr>
                      <th>User Id</th>
                      <th>User Name</th>
                      <th>Email</th>
                      <th className="text-center">Plan Validity</th>
                      <th>Subscribed Date</th>
                      <th>Expire Date</th>
                      <th>Platform</th>
                        {/* <th>Forget Password Request</th> 
                        <th>Password</th> */}
                  </tr>
              </thead>
              <tbody>
              {schoolListing}
              </tbody>
            </table></div>
          } else{
              schoolAlldata = <h3 className="nodatafound">No data found</h3>
          }
        return(
            <div className="main_contents">
              <BlockUi blocking={this.state.blocking}>
              <div className="row titleheader">
                
                <h1 className="page_title col-sm-9">Subscription</h1>
                <div className="col-md-3 text-right">
              <input type="text" id="search" className="form-control" onChange={this.searchHandle} placeholder="Search.." value={this.state.search} />
            </div>
                {/* <label>{this.state.labelHolder}</label>
                <button onClick={this.myFunction.bind(this, "hindi")}>hey</button> */}
                {/* <div className="col-sm-6 text-left">
                <Select
                    value={selectedState}
                    onChange={this.selectState}
                    options={stateOptions}
                    placeholder="Select School"
                />
                </div> */}

                {/* <div className="col-sm-4 text-right"><button type="button" className="btn btn-dark" onClick = {this.openAddOfficer}>Add User</button></div> */}
              </div>
            
            <Row>
              <Col xs="12" lg="12" className="divright">
                <Card className="mytablesright settingright">
                  <CardBody>
                    {schoolAlldata}
                    <div className="loadMoreDiv">
                        {isMorebtn}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* ///// */}
            <div className="modal-container">
               <Modal
                   show={this.state.showForAddSchool}
                //    onHide={this.close}
                   container={this}
                   aria-labelledby="contained-modal-title"
               >
                  <Form ref={(form) => this.loginFormRef1 = form} className="resetPopup" name="loginForm" onSubmit={this.handleSubmit}>
                   <Modal.Header >
                       <Modal.Title id="contained-modal-title">Add User</Modal.Title>
                   </Modal.Header>

                   <Modal.Body>
                    <div className="formbox">
                        <label>Name </label>
                        <Input type="text" className="form-control" id="addUserName" ref="addUserName" onChange={this.handleAddOfficerChange} value={this.state.addUserName} validations={[required]}/>          
                    </div>

                        <div className="formbox">
                            <label>Gender</label>
                            <input type="radio" id="radio1" name="gender" onChange={this.handleAddOfficerChange} checked={this.state.radioValue == "MALE"}/>Male
                            <input type="radio" id="radio2" name="gender" onChange={this.handleAddOfficerChange} checked={this.state.radioValue == "FEMALE"}/>Female<br></br>
                        </div>

                        <div className="formbox">
                            <label>Year Of Birth</label>
                            <Input type="text" className="form-control" id="addUserYOB" ref="addUserYOB" onChange={this.handleAddOfficerChange} value={this.state.addUserYOB} validations={[required]}/>
                        </div>
                    
                        <div className="formbox">
                            <label>Email</label>
                            <Input type="text" className="form-control" id="addUserEmail" ref="addUserEmail" onChange={this.handleAddOfficerChange} value={this.state.addUserEmail} validations={[required, email]}/>
                        </div>

                        <div className="formbox">
                          <label>Password</label>
                          <Input type="text" className="form-control" id="addUserPassword" ref="addUserPassword" onChange={this.handleAddOfficerChange} value={this.state.addUserPassword} validations={[required, maxNo]}/>
                         </div>

                        {/* <div className="formbox">
                            <label>School Id</label>
                            <Input type="text" className="form-control" id="addUserSchoolId" ref="addUserSchoolId" onChange={this.handleAddOfficerChange} value={this.state.addUserSchoolId} validations={[required]}/>
                        </div> */}
                    {/* <div className="formbox">
                      <label>Officer Designation Id</label>
                            
                    </div>
                    <div className="formbox">
                        <label>Password</label>
                        <Input type="text" className="form-control" id="addUserPassword" ref="addUserPassword" onChange={this.handleAddOfficerChange} value={this.state.addUserPassword} validations={[required, maxNo]}/>
                    </div>
                    
                    <div className="formbox">
                        <label>Username</label>
                        <Input type="text" className="form-control" id="addOfficerUsername" ref="addOfficerUsername" onChange={this.handleAddOfficerChange} value={this.state.addOfficerUsername} validations={[required]}/>
                    </div>
                        <div className="formbox">
                            <label>Active Status :</label>
                            <input type="radio" id="radio1" name="gender" onChange={this.handleAddOfficerChange} checked={this.state.radioValue == true}/>True
                            <input type="radio" id="radio2" name="gender" onChange={this.handleAddOfficerChange} checked={this.state.radioValue == false}/>False<br></br>
                        </div> */}
                    {/* <button type="button" className="btn btn-primary" onClick={this.createPass}>Create</button> */}
                   </Modal.Body>
                   <Modal.Footer>
                      <Button type="submit" className="savebtn btn btn-secondary">Save</Button>
                  </Modal.Footer>
                  </Form>
                  <button className="btn btn-danger" onClick={this.closeForAddOfficer}>Close</button>
               </Modal>
           </div>
            {/* ////// */}

            <div className="modal-container" style={{ height: 200 }}>
               {/* <Button
                   bsStyle="primary"
                   bsSize="large"
                   onClick={() => this.setState({ show: true })}
               >
                   Launch contained modal
               </Button> */}

               <Modal
                   show={this.state.show}
                //    onHide={this.close}
                   container={this}
                   aria-labelledby="contained-modal-title"
               >
               
                    <Form ref={(form) => this.loginFormRef = form} className="resetPopup" name="loginForm" onSubmit={this.handleEditSubmit}>
                   <Modal.Header >
                       <Modal.Title id="contained-modal-title">Subscription Plan</Modal.Title>
                   </Modal.Header>

                   <Modal.Body>
                    {/* <div className="formbox">
                        <label>Name</label>
                        <Input type="text" className="form-control" id="editName" ref="editName" onChange={this.handleChange} value={this.state.editName} validations={[required]}/>
                    </div>

                    <div className="formbox">
                            <label>Gender</label>
                            <input type="radio" id="editRadio1" name="gender" onChange={this.handleChange} checked={this.state.editRadio == "MALE"}/>Male
                            <input type="radio" id="editRadio2" name="gender" onChange={this.handleChange} checked={this.state.editRadio == "FEMALE"}/>Female<br></br>
                    </div>
                    
                    <div className="formbox">
                        <label>Year Of Birth</label>
                        <Input type="text" className="form-control" id="editYOB" ref="editYOB" onChange={this.handleChange} value={this.state.editYOB} validations={[required]}/>
                    </div>
                    <div className="formbox">
                        <label>Email</label>
                        <Input type="text" className="form-control" id="editEmail" ref="editEmail" onChange={this.handleChange} value={this.state.editEmail} validations={[required]}/>
                    </div>
                    <div className="formbox">
                        <label>Password</label>
                        <Input type="password" className="form-control" id="editPass" ref="editPass" onChange={this.handleChange} value={this.state.editPass} validations={[required]}/>
                    </div> */}


                        <div className="formbox">
                            <label>Subscription</label>
                            <input type="radio" id="subscribe" name="gender" onChange={this.handleSubscribe} checked={this.state.checksubscription == 1}/>1 month
                            <input type="radio" id="subscribe1" name="gender" onChange={this.handleSubscribe} checked={this.state.checksubscription == 6}/>6 month
                            <input type="radio" id="subscribe2" name="gender" onChange={this.handleSubscribe} checked={this.state.checksubscription == 12}/>12 month<br></br>
                        </div>


                    
                    {/* <div className="formbox">
                        <label>State Short Name</label>
                        <Input type="text" className="form-control" id="insertStateSN" ref="insertStateSN" onChange={this.handleChange} value={this.state.insertStateSN} validations={[required]}/>
                    </div> */}
                        {/* <div className="formbox">
                            <label>Comfirm Password</label>
                            <Input type="text" className="form-control" id="confirmPassword" ref="confirmPassword" onChange={this.handleChange} value={this.state.confirmPassword} validations={[minNo, maxNo]}/>{modalIcon}
                        </div> */}

                    {/* <div className="createpassword">
                    <span onClick={this.createPass}>Generate Password:</span>   {this.state.createPass}
                    </div> */}
                    {/* <button type="button" className="btn btn-primary" onClick={this.createPass}>Create</button> */}
                   </Modal.Body>

                   <Modal.Footer>
                      
                   
                      <button type="submit" className="savebtn btn btn-secondary">Save</button>
                  </Modal.Footer>
                  </Form>
                  <button className="btn btn-danger" onClick={this.closeEditSchool}>Close</button>
               </Modal>
           </div>

           </BlockUi>
          </div>
        )
    }
}

export default Subscription;